module.exports = new __parcel__URL__("pvp_vertical_divider.24456554.png").toString();